(function($, win, doc) {

    $(function() {
        // show/hide input fields depending on event/workshop selecting with
        // collectDataCompanion or collectDataParticipant
        $('.time-to-act-events .event-detail input:checked').each(function(k,v){
            var _companion = parseInt($(this).closest('.event-detail').data('companion')),
                _participant = parseInt($(this).closest('.event-detail').data('participant'));

            if (_companion === 1) {
                $('.companion').removeClass('d-none');
            }

            if (_participant === 1) {
                $('.participant').removeClass('d-none');
            }
        });

        $('.time-to-act-events .event-detail input').on('change', function(e){
            var _companion = parseInt($(this).closest('.event-detail').data('companion')),
                _participant = parseInt($(this).closest('.event-detail').data('participant'));

            $('.companion, .participant').addClass('d-none');

            if (_companion === 1) {
                $('.companion').removeClass('d-none');
            }

            if (_participant === 1) {
                $('.participant').removeClass('d-none');
            }
        });

        // make attendance name required, if radiobox is selected
        $('.attendance input[type="radio"]').on('click', function (e) {
            var _input = $(this).parent().find($('input[type="text"]'));

            if (_input.is(':visible')) {
                _input.attr('required', 'required').prop('required', true);
            } else {
                $('.attendance input[type="text"]').removeAttr('required').prop('required', false);
            }
        });

        // check if the modal input changes and remove error class
        $('.event-booking__form-error input').on('keyup', function(){
            $('.event-booking__form-error').removeClass('event-booking__form-error');
        });

        // check if one radio selection is set and show sticky element on load
        if ($('form.event-list input[type="radio"]:checked').length > 0) {
            $('.sticky-content').show();
            stickyContentText();
        } else {
            $('.sticky-content').removeAttr('style');
        }

        // check if at least one elem is checked
        $('form.event-list input[type="radio"]').on('click', function(){
            if ($('form.event-list input[type="radio"]').length > 0) {
                $('.sticky-content').show();
            } else {
                $('.sticky-content').removeAttr('style');
            }

            stickyContentText();
        });

        // show the reset-selection button, if a radio button is selected
        $('form input[type="radio"][name*="featuredEvent"]').on('click', function(){
            if ($('form input[type="radio"][name*="featuredEvent"]').length > 0) {
                $('a.reset-selection').css('display', 'inline-block');
                $('.attendance').removeClass('hidden');
            } else {
                $('a.reset-selection').removeAttr('style');
            }
        });

        // show reset button and
        // make attendance radio boxes visible, if a workshop is selected
        if ($('form input[type="radio"][name*="featuredEvent"]:checked').length > 0) {
            $('a.reset-selection').css('display', 'inline-block');
            $('.attendance').removeClass('hidden');
        }

        $('.reset-selection').on('click', function(e){
           e.preventDefault();
            $('form input[type="radio"][name*="featuredEvent"]').each(function(){
                $(this).attr('checked', false).prop('checked', false);
            });

            $(this).hide();

            $('.attendance').addClass('hidden');

            if ($('form input[type="radio"]:checked').length > 0) {
                $('.sticky-content').show();
            } else {
                $('.sticky-content').removeAttr('style');
            }

            stickyContentText();

            $('.companion, .participant').addClass('d-none');
        });

        // disabled the book now button and check radio box instead
        $('.book-now').on('click', function(e){
            e.preventDefault();
            $(this).parent().find('input').click();

            stickyContentText();
        })

        // sticky content text behaviour
        function stickyContentText() {
            var _events = [];

            if ($('.sticky-content').is(':visible')) {
                $('input[type="radio"]:checked').each(function() {
                    if ($(this).attr('name').indexOf('featuredEvent') !== -1) {
                        _events[0] = '<b>'+ $(this).parent().find('label').text().trim() +'</b>';
                    } else {
                        _events[1] = '<b>'+ $(this).parent().parent().parent().find('h2').text().trim() +'</b>';
                    }
                });

                var _filtered = _events.filter(function (el) {
                    return el != null;
                });

                var _text = 'Du hast '+ _filtered.join(' und ') +' ausgewählt. Bitte gehe auf "Code eingeben", um fortzufahren.'
                $('.sticky-content [data-text]').html(_text);
            }
        }

        // remove init class from animations on doc ready
        $('.animations').removeClass('init');

        // calculate the height for the sujet on load in
        // fullscreen
        var _containerHeight = $(window).height() - 50;
        doc.documentElement.style.setProperty('--sujet-height', _containerHeight +'px');

        $('[data-toggle="selectEvent"]').on('click', function (e) {
            var el = $(e.target);
            $(el.data('target')).val(el.data('value'));

        });

        // jump to animation
        $('[data-jump]').on('click', function(e){
           e.preventDefault();
           var _elem = $($(this).data('jump'));

            $('html, body').animate({
                scrollTop: _elem.offset().top - 200
            }, 500);
        });

        // init fullscreen on pageload
        if ($('body.layout-1 a.fullscreen').length > 0) {
            // $('body.layout-1').addClass('fullscreen')
        }

        // trigger click on the fullscreen button
        $('body.layout-1 a.fullscreen').on('click', function(e){
            e.preventDefault();
            $('body.layout-1').toggleClass('fullscreen');
        });

        // closes fullscreen on escape press
        $('html').on('keyup', function(e){
            if (e.originalEvent.key === 'Escape') {
                $('body.layout-1').removeClass('fullscreen');
            }
        });

        // opens fullscreen on clicking in the input field
        // and allows only correct patterns (0-9 a-z, 6 chars)
        $('.event-booking input[type="text"]').on('focus', function(){
            $('body.layout-1').addClass('fullscreen');
        }).on('keyup', function(){
            var _val = $(this).val(),
                _pattern = new RegExp('^[a-zA-Z0-9]{6,}$'),
                _test = _pattern.test(_val);

            if (_test === true) {
                $(this).parent().removeClass('event-booking__form-error').find('div').remove();
            }
        });

        // do a fe validation for the form
        $('.event-booking form').on('submit', function(e) {
            var _val = $('input[name*="code"]').val(),
                _pattern = new RegExp('^[a-zA-Z0-9]{6,}$'),
                _test = _pattern.test(_val);

            if (_test === false) {
                e.preventDefault();
                var _msg = $('<div />')
                    .html($('input[name*="code"]').data('error'));

                $('.event-booking__form-wrap')
                    .addClass('event-booking__form-error')
                    .append(_msg);
            }
        });

        // filter logic to filter events based on
        // data attributes
        $('.event-filter [data-filter]').on('click', function(e){
            e.preventDefault();

            $(this).closest(".event-filter").find('[data-filter]').removeClass('active');
            $(this).addClass('active');

            var selected = $(this).data('filter');

            if (selected === 'all') {
                $('.event-detail.list-view').show();
                return void(0);
            }

            var filterId = "," + selected + ",";

            $('.event-detail.list-view').hide().filter(function () {
                var ids = "," + $(this).data("filter") + ",";
                return ids.indexOf(filterId) > -1;
            }).show();
        });

        // sort events based on data attribute
        $('.event-list [data-sort]').on('click', function(e){
            e.preventDefault();

            if ($(this).hasClass('active')) {
                return void(0);
            }

            $(this).parent().parent().find('[data-sort]').removeClass('active');
            $(this).addClass('active');

            if ($(this).data('sort') === 'alphabet') {
                var _elements = $('.event-detail.list-view[data-title]'),
                    _parent = _elements.parent(),
                    _sorted = _elements.sort(function(a,b){
                        return $(b).data('title').toUpperCase() < $(a).data('title').toUpperCase() ? 1 : -1;
                    });

                _elements.remove();
                _parent.prepend(_sorted);

                return void(0);
            }

            if ($(this).data('sort') === 'date') {
                var _elements = $('.event-detail.list-view[data-date]'),
                    _parent = _elements.parent(),
                    _sorted = _elements.sort(function(a,b){
                        return $(b).data('date') < $(a).data('date') ? 1 : -1;
                    });

                _elements.remove();
                _parent.prepend(_sorted);

                return void(0);
            }
        });

        // if an optional event is selected, show the input form and set this as
        // required field
        var els = $('form[name="booking"] .togglePhone input[name*="featuredEvents"]');
        els.on('click', function() {
            var _checked = $('form[name="booking"] .togglePhone input[name*="featuredEvents"]:checked').length;
            if (_checked > 0) {
                $('.optional-mail').removeClass('hidden').find('input').attr('required', true).prop('required', true);
            } else {
                $('.optional-mail').addClass('hidden').find('input').attr('required', false).prop('required', false);
            }
        });

        setTimeout(function () {
            els.trigger('click');
        }, 0);
    });

    // resize the sujet on resizing window in fullscreen mode
    $(win).resize(function() {
        var _containerHeight = $(win).height() - 50;
        doc.documentElement.style.setProperty('--sujet-height', _containerHeight +'px');
    });

    // scroll animation css var changes
    $(win).scroll(function() {
        doc.documentElement.style.setProperty('--animation', parseInt((win.pageYOffset * 0.1)) +'px');
        doc.documentElement.style.setProperty('--rotation', parseInt((win.pageYOffset * -0.05)) +'deg');
    });
})(jQuery, window, document);
